function M(t, u, r) {
  return { r: 255 * r(t.r / 255, u.r / 255), g: 255 * r(t.g / 255, u.g / 255), b: 255 * r(t.b / 255, u.b / 255) };
}
function h(t, u) {
  return u;
}
function b(t, u, r) {
  return Math.min(Math.max(t || 0, u), r);
}
function e(t) {
  return { r: b(t.r, 0, 255), g: b(t.g, 0, 255), b: b(t.b, 0, 255), a: b(t.a, 0, 1) };
}
function f(t) {
  return { r: 255 * t.r, g: 255 * t.g, b: 255 * t.b, a: t.a };
}
function v(t) {
  return { r: t.r / 255, g: t.g / 255, b: t.b / 255, a: t.a };
}
function d(t, u) {
  u === void 0 && (u = 0);
  var r = Math.pow(10, u);
  return { r: Math.round(t.r * r) / r, g: Math.round(t.g * r) / r, b: Math.round(t.b * r) / r, a: t.a };
}
function c(t, u, r, g, a, o) {
  return (1 - u / r) * g + u / r * Math.round((1 - t) * a + t * o);
}
function O(t, u, r, g, a) {
  a === void 0 && (a = { unitInput: !1, unitOutput: !1, roundOutput: !0 }), a.unitInput && (t = f(t), u = f(u)), t = e(t);
  var o = (u = e(u)).a + t.a - u.a * t.a, i = r(t, u, g), n = e({ r: c(t.a, u.a, o, t.r, u.r, i.r), g: c(t.a, u.a, o, t.g, u.g, i.g), b: c(t.a, u.a, o, t.b, u.b, i.b), a: o });
  return n = a.unitOutput ? v(n) : a.roundOutput ? d(n) : function(p) {
    return d(p, 9);
  }(n), n;
}
function m(t, u) {
  return O(t, u, M, h);
}
export {
  m as A
};
